import { KulionerReceiptSectionProps } from "../types";
import { colors, margin } from "../constants";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { limitLengthName } from "@/app/ui/modules/receipt-v2/module";

export const renderHeader = ({
  doc,
  x,
  y,
  pageWidth,
  importLogo
}: KulionerReceiptSectionProps): number => {
  doc.setFont("helvetica", "bold");
  doc.setTextColor(colors.primary);
  doc.setFontSize(9);
  y += 2;
  doc.text(limitLengthName(AccountController.accountData.name, 35), x, y);

  const logo = importLogo?.default;
  const imageWidth = 20;
  const logoProperties = doc.getImageProperties(logo);
  const logoAspectRatio = logoProperties.height / logoProperties.width;

  doc.addImage(
    logo,
    "PNG",
    pageWidth - imageWidth - margin.right,
    y - 3,
    imageWidth,
    logoAspectRatio * imageWidth,
    "logo",
    "FAST"
  );

  return y;
};
